





















































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { GET_CUSTOMER } from '@/queries/Customer';

@Component
export default class CustomerShow extends Vue {
  public GET_CUSTOMER = GET_CUSTOMER;
  @Prop(String) public id!: string;
}
